import { Link, Text } from '@ksyos/design-system';

export function getVideoLink(instructionsVideo: 'hardwareToken' | 'app' | 'both') {
    const verificationAppVideoLink = 'https://vimeo.com/640350066/f93a89f447';
    const hardwareTokenVideoLink = 'https://vimeo.com/640352138/6f30f87dff';

    if (instructionsVideo === 'both') {
        return (
            <>
                instructievideo over de{' '}
                <Link
                    color="minimal"
                    fontWeight="normal"
                    href={verificationAppVideoLink}
                    openInNewTab
                    variant="externalLink"
                >
                    verificatieapp
                </Link>{' '}
                of{' '}
                <Link
                    color="minimal"
                    fontWeight="normal"
                    href={hardwareTokenVideoLink}
                    openInNewTab
                    variant="externalLink"
                >
                    hardware token
                </Link>
                .
            </>
        );
    } else if (instructionsVideo === 'hardwareToken') {
        return (
            <Link
                color="minimal"
                fontWeight="normal"
                href={hardwareTokenVideoLink}
                openInNewTab
                variant="externalLink"
            >
                instructievideo over de hardware token.
            </Link>
        );
    } else {
        return (
            <Link
                color="minimal"
                fontWeight="normal"
                href={verificationAppVideoLink}
                openInNewTab
                variant="externalLink"
            >
                instructievideo over de verificatieapp.
            </Link>
        );
    }
}
export function LoginMfaHelpFooter(props: { instructionsVideo: 'hardwareToken' | 'app' | 'both' }) {
    return (
        <Text
            color="minimal"
            size="sm"
        >
            Hulp nodig bij het instellen?
            <br />
            Bekijk de {getVideoLink(props.instructionsVideo)}
        </Text>
    );
}
